export default __webpack_public_path__ + "static/media/Tongue of the Eight-Way Wyrm.7fe8a32a.jpg";